/**
 * NotificationsPage — /bildirimler tam sayfa bildirim listesi.
 *
 * Bilinçli sapma: `max-w-2xl mx-auto` kullanılır (site genelindeki grid
 * layout'lardan farklı) — bu bir liste-okuma ekranı, grid değil.
 * Global Navbar App.js tarafından zaten render ediliyor, burada tekrar
 * eklenmez.
 */
import NotificationFeed from '../components/notifications/NotificationFeed';

export default function NotificationsPage() {
  return (
    <div className="min-h-screen bg-[var(--bg-app)] py-8" data-testid="notifications-page">
      <div className="max-w-2xl mx-auto px-4 sm:px-6">
        <NotificationFeed density="comfortable" />
      </div>
    </div>
  );
}
